module.exports = "/images/vendor/lightgallery/src/youtube-play.png?e6f0c233c87ddefab049c991c61e2d69";